<template>
    <div class="useful-services useful-services_grey">
        <div class="wrapper">
            <div class="useful-services__wr">
                <ClientOnly>
                    <CurrencyRatesTableSmall />
                </ClientOnly>
                <OfficesMapSmall />
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
    name: 'AdditionalWidgets',
    components: {
        CurrencyRatesTableSmall: () => {
            return import('@/components/Pages/ForIndividuals/CurrencyRates/CurrencyRatesTableSmallTemp.vue');
        },
        OfficesMapSmall: () => import('@/components/Pages/HomePage/OfficesAndATM/OfficesMapSmall.vue'),
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/home-page/index/services';
</style>
